<template>
  <StandardDialogFullScreen
    :full_element="false"
    >
    <template #nav-left>
      <v-btn
        v-if="create && image_id !== 0 || !create && images.findIndex(image => image.id === image_id) !== 0"
        icon
        large
        @click="
        nav_direction_image = 'left'
        $router.push({
          name: `${location}ImagesZoomImage`,
          params: {
            image_id: create?image_id-1:images[images.findIndex(image => image.id === image_id)-1].id,
          }
          })
          "
        >
        <v-icon large>keyboard_arrow_left</v-icon>
      </v-btn>
    </template>
    <template #nav-right>
      <v-btn
        v-if="create && image_id !== images.length-1 ||
              !create && images.findIndex(image => image.id === image_id) !==
              images.length-1"
        icon
        large
        @click="
        nav_direction_image = 'right'
        $router.push({
          name: `${location}ImagesZoomImage`,
          params: {
            image_id: create?image_id + 1:images[images.findIndex(image => image.id === image_id)+1].id,
          }
          })
          "
        >
        <v-icon large>keyboard_arrow_right</v-icon>
      </v-btn>
    </template>
    <template #header-text v-if="!create">
      <div>
        {{images.find(image => image.id === image_id).user}}
        {{images.find(image => image.id === image_id).created.substring(0, 19)}}
      </div>
      <div>{{images.find(image => image.id === image_id).comment}}</div>
    </template>
    <template #header-close>
      <v-btn
        icon
        @click="$router.push({
          name: location.substring(0, 9) !== 'WorkBench' &&
          location !== 'TaktPlanWorkPackageCopy' && location !== 'TaktPlanAddWorkPackageDetailsEditEditor'?`${location}Images`:close
          })"
        >
        <v-icon>clear</v-icon>
      </v-btn>
  </template>
  <template #content>
    <transition
      :name="`image-slide-${nav_direction_image}`"
      >
      <router-view :key="image_id"/>
    </transition>
  </template>
  </StandardDialogFullScreen>
</template>
<script>

import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
export default {
  props: [
    'image_id',
    'images',
    'location',
    'close',
    'create',
    'create_sequence'
  ],
  components: {
    StandardDialogFullScreen
  },
  data: () => ({
    nav_direction_image: 'right',
  }),
  created() {
  }
}
</script>
<style>
.image-slide-right-enter{
  transform: translateX(100vw);
}
.image-slide-right-leave-to  {
  transform: translateX(-100vw);
}
.image-slide-left-enter{
  transform: translateX(-100vw);
}
.image-slide-left-leave-to  {
  transform: translateX(100vw);
}
.image-slide-right-enter-active, .image-slide-right-leave-active,
.image-slide-left-enter-active, .image-slide-left-leave-active {
  transition: all 0.5s ease-in-out;
}
</style>
